import { ServiceType, ServiceTypeLabel } from '../hooks/context/serviceType/models';
import { Address } from 'olo-service';

type DateTime = {
  label: string;
  dateTime: number;
};

type CurrentDateTime = DateTime | undefined;

export const isOrderTypeReadOnly = (serviceTypes: ServiceTypeLabel[], itemCount: number): boolean => {
  return serviceTypes.length <= 1 || !itemCount;
};

export const isForWhenReadOnly = (showScheduledOrderState: boolean, itemCount: number): boolean => {
  return !showScheduledOrderState || !itemCount;
};

export const noDeliveryAddress = (serviceType: string, deliveryAddress: Address | undefined): boolean => {
  return serviceType === ServiceType.DELIVERY && !deliveryAddress;
};

export const hasDateOrTime = (currentDate: CurrentDateTime, currentTime: CurrentDateTime): boolean => {
  return currentDate || currentTime ? true : false;
};

export const hasDateAndTime = (currentDate: CurrentDateTime, currentTime: CurrentDateTime): boolean => {
  return !!currentDate && !!currentTime;
};

export const canScheduleOrder = (showScheduledOrderClosedState: any, isAcceptingOrders: any) => {
    return !showScheduledOrderClosedState && !!isAcceptingOrders;
};
